import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { ReactComponent as SearchIcon } from "../../../../../../../../assets/svg/solo-chat/searchIcon.svg";
import { Text } from './Text';
import { Text as TText } from '../../types';
import { AddText } from './AddText';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any | null;
	contents: (TText & { id: string; updatedAt: string|null; createdAt: string })[];
	hasMore:boolean;
	refetchContent: () => void;
	loadMore: () => void;
	onSearch: (val: string) => void;
	setInputText: (val: string) => void;
	inputText: string;
};

export function TextList(props: Props) {
    const { scrollRef, contents: texts, hasMore, refetchContent, loadMore } = props;
    const [inputText, setInputText] = useState("");

	const filteredTexts = texts.filter(text => text.contentValue.text.toLowerCase().trim().includes(inputText.toLowerCase().trim()));

    let searchHandler = (value: string) => {
        setInputText(value);
    };

	return (
		<div className={style.contentList}>
			<Header {...props} onSearch={searchHandler} setInputText={setInputText} inputText={inputText} />
			<div className={style.selector} style={{marginBottom:"10px"}}> 
				<div>
					<p>Text</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget" ref={scrollRef} style={{overflow: "auto", height: "calc(100vh - 200px)",padding:"0px 4px"}}>
                {filteredTexts.length > 0?
					<InfiniteScroll
						dataLength={filteredTexts.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}
					>
						{filteredTexts.map((el) => (
							<Text key={el.id} text={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	const { onSearch, inputText } = props;
	
	return (
		<div className={style.header}>
			<div className={style.searchInput}>
				<SearchIcon className={style.searchInputSearchIcon} />
				<input className={style.searchInputField}
					onChange={(e) => onSearch(e.target.value)}
					value={inputText}
					type="search"
					placeholder='Search message'
					id="default-search"
				/>
			</div>
			{ canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
				<img src={AddIcon} alt="add" />
				<span>Add Text</span>
			</button>
			}
			{isOpen && (
				<AddText
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
